module.exports = __webpack_public_path__ + "static/media/image_32.c96281da.png";